import React from "react";
import { colors } from "../../../../../../themes/Colors";
import useWindowDimensions from "../../../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { BaseButtons } from "../../../../../common-components";
import BuzzCard from "../buzz-card/BuzzCard";

const BuzzPostPopUp = ({ setClose, selectedPost }) => {
  const { width, height } = useWindowDimensions();
  console.log("selectedPost", selectedPost);
  const postTypeSplit = (postType) => {
    const splitArray = postType.split(",");

    return splitArray;
  };

  const tagsSplit = (tags) => {
    const splitArray = tags.split(",");

    return splitArray;
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        width: 500,
        backgroundColor: colors.white,
        height: height - 65,
        zIndex: 300,
        right: 0,
        overflowY: "scroll",
        scrollbarWidth: "none",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 10,
          left: 10,
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"X"}
          backgroundColor={colors.secondaryDarkBlue}
          borderRadius={4}
          width={40}
          onClick={() => setClose(null)}
        />
        <div style={{ fontSize: 20, fontWeight: "bold", marginLeft: 20 }}>
          BUZZ POST VIEW
        </div>
      </div>
      <BuzzCard
        buzzTitle={selectedPost.title}
        senderTitle={selectedPost.senderDetails}
        quickDescription={selectedPost.shortDescription}
        longDescription={selectedPost.longDescription}
        postType={postTypeSplit(selectedPost.postType[0])[0]}
        subPostType={postTypeSplit(selectedPost.postType[0])[1]}
        sourceLink={selectedPost.sourceLink}
        tagsData={tagsSplit(selectedPost.tags[0])}
        option2={true}
        postId={selectedPost.postId}
        selectedItem={selectedPost}
        index={1}
        date={selectedPost.dateCreated}
      />
    </div>
  );
};

export default BuzzPostPopUp;
